/**
 * Returns an error to be thrown when attempting to attach an already-attached scroll strategy.
 */
export function getMdScrollStrategyAlreadyAttachedError() {
    return Error("Scroll strategy has already been attached.");
}
//# sourceMappingURL=scroll-strategy.js.map


//////////////////
// WEBPACK FOOTER
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/md2/core/overlay/scroll/scroll-strategy.js
// module id = null
// module chunks = 